import {ticker as new_ticker} from './ticker.js'
//const raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame
//const cancel_raf = window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelRequestAnimationFrame || window.mozCancelAnimationFrame || window.oCancelRequestAnimationFrame || window.oCancelAnimationFrame || window.msCancelRequestAnimationFrame

const element_style = document.createElement('div').style

const vendor = (() => {
	const vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
	l = vendors.length
	let i = 0, transform
	for (; i < l; i++) {
		transform = vendors[i] + 'ransform';
		if (transform in element_style) {
			return vendors[i].substr(0, vendors[i].length - 1);
		}
	}

	return false
})()

function round (value, decimals)
{
	const factor = 10 ** decimals;
	const roundedValue = Math.round(value * factor) / factor || 0;
	const roundedString = roundedValue.toString();

	const [integerPart, decimalPart = ''] = roundedString.split('.');
	const paddedDecimalPart = decimalPart.padEnd(decimals, '0');

	return `${integerPart}.${paddedDecimalPart}`;
}

function prefix_style (style)
{
	if (vendor === false) return false;
	if (vendor === '') return style
	return vendor + style.charAt(0).toUpperCase() + style.substr(1)
}

const style = Object.freeze({
	transform: prefix_style('transform'),
	transitionTimingFunction: prefix_style('transitionTimingFunction'),
	transitionDuration: prefix_style('transitionDuration'),
	transitionDelay: prefix_style('transitionDelay'),
	transformOrigin: prefix_style('transformOrigin'),
	touchAction: prefix_style('touchAction')
})

function has_pointer ()
{
	return !!(window.PointerEvent || window.MSPointerEvent)
}

function has_touch ()
{
	return 'ontouchstart' in window
}

export function new_scroll ({
	wrapper = '#scroll',
	events_passthrough = true,
	items = '.row',
	bind_to_wrapper = (typeof window.onmousedown === "undefined"),
	startx = 0,
	starty = 0,
	update_row =null,
	use_transform = true,
	compositing = true,
	tap = false,
	deceleration = 0.0015,
	click = undefined,
	prevent_default = true,
	snap = false,
	prevent_default_exception = {tag_name: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/},
	scrollx = false,
	scrolly = true,
	enable_pointer_events = has_pointer() && !has_touch(),
	enable_touch_events = has_touch(),
	enable_mouse_events = has_pointer() || has_touch(),
	use_transition = true,
	momentum_limit_time = 300,
	momentum_limit_distance = 15,
	swipe_bounce_time = 500,
	swipe_time = 2500,
	direction_lock_threshold = 5,
	bounce = true,
	scroller = undefined,
	infinite_limit = undefined,
	infinite_use_transform = true,
	snap_threshold = 0.333,
	snap_step_x = undefined,
	snap_step_y = undefined,
	snap_speed = undefined,
	initial_len = undefined,
	carousel = false,
	infinite = false,
	bounce_time = 600,
	bounce_easing = '',
	free_scrolling = false

} = {})
{
	wrapper = typeof wrapper == 'string' ? document.querySelector(wrapper) : wrapper
	scroller = typeof scroller == 'string' ? wrapper.querySelector(scroller) : scroller
	if (!scroller) {
		scroller = wrapper.children[0]
	}


	infinite = carousel ? true : infinite
	bounce = carousel ? false : bounce

	const scroller_style = scroller.style, empty_func = () => 0,
	ticker = new_ticker()/*.fps(30)*/, events = {}

	let modulus = undefined
	let wrapper_width, wrapper_height,
	scroller_width, scroller_height,
	has_horizontal_scroll, has_vertical_scroll,
	max_scrollx, max_scrolly,
	min_scrolly, min_scrollx,
	end_time,
	direction_x = 0, direction_y = 0,
	wrapper_offset = -1,
	/*time = -1,*/
	enabled = false,
	x = 0, y = 0,
	initiated_event,
	start_x, start_y,
	dest_x, dest_y,
	transition_time_val, transition_timing_function_val,
	abs_start_x, abs_start_y,
	point_x, point_y,
	dist_x = 0, dist_y = 0,
	current_page = {},
	pages = undefined,
	resize_polling = 60,
	indicators = [],
	item_height, item_master, items_width, items_height, item_width, items_size, scroller_size, item_size,
	mouse_wheel_speed = 2,
	invert_wheel_direction = false,
	snap_threshold_x = undefined,
	snap_threshold_y = undefined,
	scroll_x = false, scroll_y = true,
	start_time,
	dest_time,
	duration,
	direction_locked = false,
	items_per_page,
	wheel_timeout = undefined,
	momentum_enabled = true,
	damping_factor = 0.33,
	infinite_upper_buffer_size,
	moved = false, is_in_transition = false, animating = false


	const event_type = Object.freeze({
		touchstart: 1,
		touchmove: 1,
		touchend: 1,

		mousedown: 2,
		mousemove: 2,
		mouseup: 2,

		pointerdown: 3,
		pointermove: 3,
		pointerup: 3,

		MSPointerDown: 3,
		MSPointerMove: 3,
		MSPointerUp: 3
	})

	const ease = Object.freeze({

		swipe: {
			style: 'cubic-bezier(0.23, 1, 0.32, 1)',
			fn: function (t) {
				return 1 + (--t * t * t * t * t)
			}
		},

		swipeBounce: {
			style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
			fn: function (t) {
				return t * (2 - t)
			}
		},

		quadratic: {
			style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
			fn: function (k) {
				return k * (2 - k);
			}
		},
		circular: {
			style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
			fn: function (k) {
				return Math.sqrt(1 - (--k * k));
			}
		},
		back: {
			style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
			fn: function (k) {
				const b = 4;
				return (k = k - 1) * k * ((b + 1) * k + b) + 1;
			}
		},
		bounce: {
			style: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			fn: function (t) {
				return 1 - (--t * t * t * t)
			}
		},
		/*bounce: {
		 style: '',
		 fn: function (k) {
		 if ((k /= 1) < (1 / 2.75)) {
		 return 7.5625 * k * k;
		 } else if (k < (2 / 2.75)) {
		 return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
		 } else if (k < (2.5 / 2.75)) {
		 return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
		 } else {
		 return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
		 }
		 }
		 },*/
		elastic: {
			style: '',
			fn: function (k) {
				const f = 0.22,
				e = 0.4;

				if (k === 0) { return 0; }
				if (k === 1) { return 1; }

				return (e * Math.pow(2, -10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1);
			}
		}
	})

	const has_perspective = prefix_style('perspective') in element_style,
	has_transform = style.transform !== false,
	has_transition = prefix_style('transition') in element_style
	const translateZ = compositing && has_perspective ? ' translateZ(0)' : ''

	events_passthrough = events_passthrough === true ? 'vertical' : events_passthrough
	prevent_default = !events_passthrough && prevent_default
	scroll_y = events_passthrough == 'vertical' ? false : scroll_y
	scroll_x = events_passthrough == 'horizontal' ? false : scroll_x
	free_scrolling = free_scrolling && !events_passthrough
	direction_lock_threshold = events_passthrough ? 0 : direction_lock_threshold
	bounce_easing = typeof bounce_easing == 'string' ? ease[bounce_easing] || ease.bounce : bounce_easing
	invert_wheel_direction = invert_wheel_direction ? -1 : 1

	if (tap === true) {
		tap = 'tap';
	}

	if (!use_transition && !use_transform) {
		if (!(/relative|absolute/i).test(scroller_style.position)) {
			scroller_style.position = "relative";
		}
	}

	const scroll = {
		destroy: function () {

		},

		scroll_to: function (x, y)
		{
			translate(x, y)

			//translate(x, y)
			//apply_scroll_transform(x, y)
			repaint()
//			ticker.wake()

			//reorder_items(x, y)
		},

		on,
		get_computed_position,

		item_width: () => item_width,

		scroller_size: () => scroller_size,

		infinite_limit: () => infinite_limit,

		x: () => x,
		y: () => y
	}



	function on (type, fn)
	{
		if (!events[type]) {
			events[type] = [];
		}

		events[type].push(fn);
	}

	function off (type, fn)
	{
		if (!events[type]) {
			return;
		}

		const index = events[type].indexOf(fn);
		if (index > -1) {
			events[type].splice(index, 1);
		}
	}

	function momentum (current, start, time, lower_margin, upper_margin, wrapper_size, deceleration)
	{

		let distance = current - start,
		speed = Math.abs(distance) / time,
		rate = 15,
		destination,
		duration = Math.min(swipe_time, (speed * 2) / deceleration)
		//duration = 2500

		deceleration = deceleration || 0.0006

		log("momentum start at " + current)

		destination = current + (speed * speed) / (2 * deceleration) * (distance < 0 ? -1 : 1);
		//destination = current + (speed / deceleration) * (distance < 0 ? -1 : 1)

		//duration = speed / deceleration

		if (!carousel) {
			if (destination < lower_margin) {
				//destination = wrapper_size ? lower_margin - (wrapper_size / 2.5 * (speed / 8)) : lower_margin;

				destination = wrapper_size ? Math.max(
				lower_margin - wrapper_size / 4,
				lower_margin - (wrapper_size / rate) * speed) : lower_margin

				//distance = Math.abs(destination - current);
				duration = swipe_bounce_time
				//duration = distance / speed
			}
			else if (destination > upper_margin) {
				//destination = wrapper_size ? wrapper_size / 2.5 * (speed / 8) : 0;
				destination = wrapper_size
				? Math.min(
				upper_margin + wrapper_size / 4,
				upper_margin + (wrapper_size / rate) * speed) : upper_margin
				//distance = Math.abs(current) + destination;
				duration = swipe_bounce_time
				//duration = distance / speed
			}
		}

		log("momentum destination: " + destination)

		return {
			destination: Math.round(destination),
			duration: duration
		};
	}

	function touch_action (event_passthrough, add_pinch)
	{
		let touch_action = 'none';
		if (event_passthrough === 'vertical') {
			touch_action = 'pan-y';
		}
		else if (event_passthrough === 'horizontal') {
			touch_action = 'pan-x';
		}

		if (add_pinch && touch_action !== 'none') {
			touch_action += ' pinch-zoom';
		}

		return touch_action;
	}

	function add_event (elem, type, fn, {passive = true, capture = false} = {})
	{
		elem.addEventListener(type, fn, {passive, capture})
	}

	function remove_event (elem, type, fn, {passive = true, capture = false} = {})
	{
		elem.removeEventListener(type, fn, {passive, capture})
	}

	function normalize_wheel (e)
	{

		const PIXEL_STEP = 10;
		const LINE_HEIGHT = 40;
		const PAGE_HEIGHT = 800;

		let sx = 0, sy = 0,       // spin_x, spin_y
		px = 0, py = 0;       // pixel_x, pixel_y

		if ('detail' in e) { sy = e.detail }
		if ('wheelDelta' in e) { sy = -e.wheelDelta / 120 }
		if ('wheelDeltaY' in e) { sy = -e.wheelDeltaY / 120 }
		if ('wheelDeltaX' in e) { sx = -e.wheelDeltaX / 120 }

		// side scrolling on Firefox with DOMMouseScroll
		if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
			sx = sy
			sy = 0
		}


		px = sx * PIXEL_STEP
		py = sy * PIXEL_STEP

		if ('deltaY' in e) { py = e.deltaY }
		if ('deltaX' in e) { px = e.deltaX }

		if ((px || py) && e.deltaMode) {
			if (e.deltaMode === 1) {          // delta in LINE units
				px *= LINE_HEIGHT;
				py *= LINE_HEIGHT;
			}
			else {                             // delta in PAGE units
				px *= PAGE_HEIGHT;
				py *= PAGE_HEIGHT;
			}
		}

		// Fall-back if spin cannot be determined
		if (px && !sx) { sx = (px < 1) ? -1 : 1; }
		if (py && !sy) { sy = (py < 1) ? -1 : 1; }

		e.normalized = {
			spin_x: -sx,
			spin_y: -sy,
			px: -px,
			py: -py
		}

		return e
	}

	function on_wheel (e)
	{
		if (!enabled) {
			return
		}

		//e.preventDefault()

		e = normalize_wheel(e)

		let wheel_delta_x, wheel_delta_y,
		new_x, new_y, abs_dist_x, abs_dist_y

		wheel_delta_x = e.normalized.px, wheel_delta_y = e.normalized.py

		if (wheel_timeout === undefined) {
			on_start_scroll()
			moved = true
		}

		clearTimeout(wheel_timeout)

		wheel_timeout = setTimeout(() => {
			if (!snap) {
				on_end_scroll()
			}

			wheel_timeout = undefined
			moved = false
		}, 25)

		/*if ('deltaX' in e) {
		 if (e.deltaMode === 1) {
		 wheel_delta_x = -e.deltaX * mouse_wheel_speed
		 wheel_delta_y = -e.deltaY * mouse_wheel_speed
		 } else {
		 wheel_delta_x = -e.deltaX
		 wheel_delta_y = -e.deltaY
		 }

		 console.log(e.rawDeltaX)
		 } else if ('wheelDeltaX' in e) {
		 wheel_delta_x = e.wheelDeltaX / 120 * mouse_wheel_speed
		 wheel_delta_y = e.wheelDeltaY / 120 * mouse_wheel_speed
		 } else if ('wheelDelta' in e) {
		 wheel_delta_x = wheel_delta_y = e.wheelDelta / 120 * mouse_wheel_speed
		 } else if ('detail' in e) {
		 wheel_delta_x = wheel_delta_y = -e.detail / 3 * mouse_wheel_speed
		 } else {
		 return
		 }*/

		dist_x += wheel_delta_x
		dist_y += wheel_delta_y
		abs_dist_x = Math.abs(dist_x)
		abs_dist_y = Math.abs(dist_y)

		const lock = lock_opposite_direction(e, abs_dist_x, abs_dist_y, wheel_delta_x, wheel_delta_y)

		wheel_delta_x = has_horizontal_scroll ? lock.x : 0
		wheel_delta_y = has_vertical_scroll ? lock.y : 0

		wheel_delta_x *= invert_wheel_direction
		wheel_delta_y *= invert_wheel_direction

		/*if (!has_vertical_scroll) {
		 wheel_delta_x = wheel_delta_y;
		 wheel_delta_y = 0;
		 }*/

		if (snap) {
			new_x = current_page.page_x;
			new_y = current_page.page_y;

			if (wheel_delta_x > 0) {
				new_x--;
			}
			else if (wheel_delta_x < 0) {
				new_x++;
			}

			if (wheel_delta_y > 0) {
				new_y--;
			}
			else if (wheel_delta_y < 0) {
				new_y++;
			}

			scroll_to_page(new_x, new_y)

			return
		}

		new_x = x + (scrollx ? wheel_delta_x : 0)
		new_y = y + (scrolly ? wheel_delta_y : 0)
		direction_x = wheel_delta_x > 0 ? -1 : wheel_delta_x < 0 ? 1 : 0
		direction_y = wheel_delta_y > 0 ? -1 : wheel_delta_y < 0 ? 1 : 0

		/*if (new_x > min_scrollx && new_x > 0) {
		 alert(new_x)
		 new_x = min_scrollx;
		 } else */
		if (new_x < max_scrollx) {
			new_x = max_scrollx;
		}

		if (new_y > min_scrolly) {
			new_y = 0;
		}
		else if (new_y < max_scrolly) {
			new_y = max_scrolly;
		}

		//e.preventDefault()

		//trigger_event('scroll')

		scroll_to(new_x, new_y)

		return false

	}

	function check_prevent_default_exception (el, exceptions)
	{
		for (let i in exceptions) {
			if (exceptions[i].test(el[i])) {
				return true;
			}
		}

		return false;
	}

	function get_computed_position ()
	{
		let matrix = window.getComputedStyle(scroller, null), x, y

		if (use_transform) {
			matrix = matrix[style.transform].split(')')[0].split(', ')
			x = +(matrix[12] || matrix[4]) || 0
			y = +(matrix[13] || matrix[5]) || 0
		}
		else {
			x = +matrix.left.replace(/[^-\d.]/g, '');
			y = +matrix.top.replace(/[^-\d.]/g, '');
		}

		log('get_computed_position(' + x + ',' + y + ')')

		return {x: x, y: y}
	}

	function now ()
	{
		return new Date().getTime()
		//return window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
	}

	//const now = Date.now || function () { new Date().getTime()}

	function on_start (e)
	{
		if (event_type[e.type] !== 1) {
			let button = e.button
			if (!e.which) {
				/* IE workaround */
				button = (e.button < 2) ? 0 :
				((e.button === 4) ? 1 : 2)
			}

			if (button !== 0) {
				return
			}
		}

		if (!enabled || (initiated_event && event_type[e.type] !== initiated_event)) {
			return
		}


		/*if (prevent_default && !is_buggy_android() &&
		 !check_prevent_default_exception(e.target, prevent_default_exception)) {
		 }*/

		const point = e.touches ? e.touches[0] : e

		initiated_event = event_type[e.type]
		moved = false
		dist_x = 0
		dist_y = 0
		direction_x = 0
		direction_y = 0

		direction_locked = 0
		start_time = now()

		const pos = get_computed_position()
		x = pos.x
		y = pos.y

		log(`on_start start_time=${start_time}`)

		if (use_transition && is_in_transition) {
			is_in_transition = 0

			transition_time(0)

			translate(x, y)

			on_end_scroll()

		}
		else if (!use_transition && animating) {
			animating = false
			on_end_scroll()
		}

		start_x = x
		start_y = y
		abs_start_x = x
		abs_start_y = y
		point_x = point.pageX
		point_y = point.pageY

	}

	function do_tap (e, event_name)
	{
		var ev = document.createEvent('Event')
		ev.initEvent(event_name, true, true)
		ev.pageX = e.pageX
		ev.pageY = e.pageY
		e.target.dispatchEvent(ev)
	}

	function do_click (e)
	{
		const target = e.target

		if (!(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName)) {
			// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
			// initMouseEvent is deprecated
			const ev = document.createEvent(window.MouseEvent ? 'MouseEvents' : 'Event');
			ev.initEvent('click', true, true)
			ev.view = e.view || window
			ev.detail = 1
			ev.screenX = target.screenX || 0
			ev.screenY = target.screenY || 0
			ev.clientX = target.clientX || 0
			ev.clientY = target.clientY || 0
			ev.ctrlKey = !!e.ctrlKey
			ev.altKey = !!e.altKey
			ev.shiftKey = !!e.shiftKey
			ev.metaKey = !!e.metaKey
			ev.button = 0
			ev.relatedTarget = null
			ev._constructed = true
			target.dispatchEvent(ev);
		}
	}

	function on_flick ()
	{
		const time = snap_speed || Math.max(
		Math.max(Math.min(Math.abs(x - start_x), 1000),
		Math.min(Math.abs(y - start_y), 1000)
		), 300)

		scroll_to_page(current_page.page_x + direction_x,
		current_page.page_y + direction_y, time)
	}

	function nearest_snap (x, y)
	{
		if (!pages.length) {
			return {x: 0, y: 0, page_x: 0, page_y: 0}
		}

		let i = 0, l = pages.length, m = 0, px = 0, py = 0

		// Check if we exceeded the snap threshold
		if (Math.abs(x - abs_start_x) < snap_threshold_x &&
		Math.abs(y - abs_start_y) < snap_threshold_y)
		{
			return current_page
		}

		for (; i < l; i++) {
			if (x >= pages[i][0].cx) {
				x = pages[i][0].x;
				break;
			}
		}

		l = pages[i].length

		for (; m < l; m++) {
			if (y >= pages[0][m].cy) {
				y = pages[0][m].y;
				break;
			}
		}

		if (i === current_page.page_x) {
			i += direction_x
			if (i < 0) {
				i = 0
			}
			else if (i >= this.pages.length) {
				i = pages.length - 1
			}

			//x = this.pages[i][0].x
		}


	}

	function on_end (e)
	{
		if (!enabled || event_type[e.type] !== initiated_event) {
			return;
		}

		if (prevent_default && !check_prevent_default_exception(e.target, prevent_default_exception)) {
			//e.preventDefault();
		}

		let point = e.changedTouches ? e.changedTouches[0] : e,
		momentum_x,
		momentum_y,
		duration = now() - start_time,
		new_x = Math.round(dest_x),
		new_y = Math.round(dest_y),
		abs_distx = Math.abs(new_x - start_x),
		abs_disty = Math.abs(new_y - start_y),
		time = 0,
		easing = ''

		//is_in_transition = 0
		initiated_event = 0
		end_time = now()

		if (reset_position(bounce_time)) {
			// reset if outside of the boundaries
			on_end_scroll()
			return
		}

		scroll_to(new_x, new_y)

		if (!moved) {
			if (tap) {
				do_tap(e, tap);
			}

			if (click) {
				do_click(e)
			}

			//trigger_event('cancelScrolling')
			return
		}

		//wrapper.style[style.touchAction] = touch_action(events_passthrough, true)

		moved = false

		log(`on_end duration=${duration} dist_x=${dist_x} dist_y=${dist_y}`)


		/*if (duration < 200 && dist_x < 100 && dist_y < 100) {
		 on_flick()
		 return
		 }*/

		if (check_momentum(abs_distx, abs_disty, duration)) {
			// start momentum animation if needed
			momentum_x = {destination: new_x, duration: 0}
			momentum_y = {destination: new_y, duration: 0}

			if (has_horizontal_scroll) {
				momentum_x = momentum(x, start_x, duration, max_scrollx, min_scrollx,
				bounce ? wrapper_width : 0, deceleration)
			}

			if (has_vertical_scroll) {
				momentum_y = momentum(y, start_y, duration, max_scrolly, min_scrolly,
				bounce ? wrapper_height : 0, deceleration)
			}

			new_x = momentum_x.destination
			new_y = momentum_y.destination
			time = Math.max(momentum_x.duration, momentum_y.duration)

			log("momentum detected " + time)

			//easing = ease.quadratic
		}

		if (snap)
		{
			const snap = nearest_snap(new_x, new_y)

		}


		if (new_x !== x || new_y !== y) {
			// change easing function when scroller goes out of the boundaries
			if (new_x > 0 || new_x < max_scrollx || new_y > 0 || new_y < max_scrolly) {
				//easing = ease.quadratic;
			}

			scroll_to(new_x, new_y, time, easing)
		}
		else {
			on_end_scroll()
			//trigger_event('endScrolling')
		}
	}

	function check_momentum (abs_distx, abs_disty, duration)
	{
		return momentum_enabled && duration < momentum_limit_time &&
		scrollx && abs_distx > momentum_limit_distance || scrolly && abs_disty > momentum_limit_time
	}

	function perform_damping_x (delta, damping_factor)
	{
		return perform_damping(dest_x, min_scrollx, max_scrollx, delta, damping_factor)
	}

	function perform_damping_y (delta, damping_factor)
	{
		return perform_damping(dest_y, min_scrolly, max_scrolly, delta, damping_factor)
	}


	function perform_damping (cur_pos, min_scroll_pos, max_scroll_pos, delta, damping_factor)
	{
		let new_pos = cur_pos + delta
		if (!carousel) {
			if (new_pos > min_scroll_pos || new_pos < max_scroll_pos) {
				new_pos = bounce ? y + delta / 3 : new_pos > 0 ? 0 : max_scroll_pos;
			}

			if (new_pos > min_scroll_pos || new_pos < max_scroll_pos) {
				if (
				(new_pos > min_scroll_pos && bounce) ||
				(new_pos < max_scroll_pos && bounce)
				)
				{
					new_pos = cur_pos + delta * damping_factor
				}
				else {
					new_pos = new_pos > min_scroll_pos ? min_scroll_pos : max_scroll_pos
				}
			}
		}

		return new_pos
	}


	function lock_opposite_direction (e, abs_dist_x, abs_dist_y, delta_x, delta_y)
	{

		log(`lock_opposite_direction(abs_dist_x=${abs_dist_x},abs_dist_y=${abs_dist_y})`)

		// lock the opposite direction
		if (!direction_locked && !free_scrolling) {
			if (abs_dist_x > abs_dist_y + direction_lock_threshold) {
				direction_locked = 'h';		// lock horizontally
			}
			else if (abs_dist_y >= abs_dist_x + direction_lock_threshold) {
				direction_locked = 'v';		// lock vertically
			}
			else {
				direction_locked = 'n';		// no lock
			}
		}

		log('direction_locked ' + direction_locked)

		if (direction_locked === 'h') {
			if (events_passthrough === 'vertical') {
				log('prevent vertical event passthrough')
				e.preventDefault()

			}
			else {
				return {
					x: delta_x,
					y: 0
				}
			}
		}
		else if (direction_locked === 'v') {

			if (events_passthrough === 'horizontal') {
				log('prevent horizontal event passthrough')
				e.preventDefault();

			}
			else {
				return {
					x: 0,
					y: delta_y
				}
			}
		}

		return {
			x: delta_x,
			y: delta_y
		}
	}

	function on_move (e)
	{


		if (!enabled || event_type[e.type] !== initiated_event) {
			return
		}


		/*if (prevent_default) {
		 e.preventDefault()
		 }*/

		const point = e.touches ? e.touches[0] : e
		let delta_x = point.pageX - point_x,
		delta_y = point.pageY - point_y,
		timestamp = now(),
		new_x, new_y,
		abs_dist_x, abs_dist_y

		point_x = point.pageX
		point_y = point.pageY

		dist_x += delta_x
		dist_y += delta_y
		abs_dist_x = Math.abs(dist_x)
		abs_dist_y = Math.abs(dist_y)

		if (timestamp - end_time > 300 && (abs_dist_x < 10 && abs_dist_y < 10)) {
			return
		}

		const lock = lock_opposite_direction(e, abs_dist_x, abs_dist_y, delta_x, delta_y)

		delta_x = has_horizontal_scroll ? lock.x : 0
		delta_y = has_vertical_scroll ? lock.y : 0

		new_x = perform_damping_x(delta_x, damping_factor)
		new_y = perform_damping_y(delta_y, damping_factor)

		direction_x = delta_x > 0 ? -1 : delta_x < 0 ? 1 : 0
		direction_y = delta_y > 0 ? -1 : delta_y < 0 ? 1 : 0

		if (!moved) {
			on_start_scroll()
			//trigger_event('startScrolling');
		}

		moved = true

		log("on_move(dist_x=" + dist_x + ",delta_x=" + delta_x + ",point_x" + point_x + ",new_x=" + new_x + ",x=" + x + ",point.pageX=" + point.pageX + ")")

		translate(new_x, new_y)

		if (timestamp - start_time > 300) {
			start_time = timestamp
			start_x = x
			start_y = y
		}

		trigger_event('scroll')

	}

	let resize_timeout

	function on_resize (e)
	{

		clearTimeout(resize_timeout)
		resize_timeout = setTimeout(refresh, resize_polling)
	}

	function on_key (e)
	{

	}

	function on_transition_run (e)
	{
	}


	function on_animation_iteration (e)
	{
	}

	function on_animation_start (e)
	{
		const repaint = () => {

			const computedStyle = window.getComputedStyle(scroller);

			const transformMatrix = computedStyle.transform;
			const matrix = new WebKitCSSMatrix(transformMatrix); // Für WebKit-Browser wie Chrome und Safari
			const translateX = matrix.m41; // X-Offset
			//const x = Math.round(translateX)
			const x = translateX

			/*translate(x, y)
			 apply_scroll_transform(x, y)*/

			reorder_items(x, y)
			//raf(repaint)

		}

		//repaint()

	}

	function on_transition_end (e)
	{
		if (is_in_transition) {
			is_in_transition = 0

			transition_time()

			if (!reset_position(bounce_time)) {

				on_end_scroll()

				//trigger_event('endScrolling')
			}
		}
	}


	function is_enabled ()
	{
		// TODO
		return false
	}

	function handle_event (e)
	{

		switch (e.type) {
		case 'touchstart':
		case 'pointerdown':
		case 'MSPointerDown':
		case 'mousedown':
			on_start(e)
			break
		case 'touchmove':
		case 'pointermove':
		case 'MSPointerMove':
		case 'mousemove':
			on_move(e)
			break
		case 'touchend':
		case 'pointerup':
		case 'MSPointerUp':
		case 'mouseup':
		case 'touchcancel':
		case 'pointercancel':
		case 'MSPointerCancel':
		case 'mousecancel':
			on_end(e)
			break
		case 'orientationchange':
		case 'resize':
			on_resize(e)
			break
		case 'transitionrun':
		case 'webkitTransitionRun':
		case 'oTransitionRun':
		case 'MSTransitionRun':
			on_transition_run(e)
			break
		case 'animationstart':
			on_animation_start(e)
			break
		case 'animationiteration':
			on_animation_iteration(e)
			break
		case 'transitionend':
		case 'webkitTransitionEnd':
		case 'oTransitionEnd':
		case 'MSTransitionEnd':
			on_transition_end(e)
			break
		case 'wheel':
		case 'DOMMouseScroll':
		case 'mousewheel':
			return on_wheel(e)
		case 'keydown':
			on_key(e)
			break
		case 'click':
			if (is_enabled() && e._constructed) {
				e.preventDefault()
				e.stopPropagation()
			}
			break
		}
	}

	function prefix_pointer_event (e)
	{
		return window.MSPointerEvent ?
		'MSPointer' + e.charAt(7).toUpperCase() + e.substr(8) : e
	}

	function install_events ()
	{
		init_events(false)
	}

	function rect (elem)
	{
		const style = window.getComputedStyle ? getComputedStyle(elem, null) : elem.currentStyle;

		const margin_left = parseInt(style.marginLeft) || 0
		const margin_right = parseInt(style.marginRight) || 0
		const margin_top = parseInt(style.marginTop) || 0
		const margin_bottom = parseInt(style.marginBottom) || 0

		let outer_width = elem.offsetWidth
		let outer_height = elem.offsetHeight
		let top = elem.offsetTop
		let left = elem.offsetLeft

		if (elem instanceof SVGElement || elem instanceof HTMLElement) {

			const rect = elem.getBoundingClientRect();
			outer_width = rect.width
			outer_height = rect.height
			top = rect.top
			left = rect.left
		}

		const width = outer_width + margin_left + margin_right
		const height = outer_height + margin_top + margin_bottom

		return {
			top, left, outer_width, outer_height, width, height
		};
	}

	function listen_resize (elem, callback)
	{
		let r = rect(elem)

		function test ()
		{
			let cur_rect = rect(elem)
			if (r.width !== cur_rect.width ||
			r.height !== cur_rect.height)
			{
				callback()
				r = cur_rect
			}
		}

		//ticker.listen(test)
	}

	function init_events (remove)
	{
		const event = remove ? remove_event : add_event,
		target = bind_to_wrapper ? wrapper : window

		//listen_resize(wrapper, refresh)

		event(wrapper, 'wheel', handle_event, {passive: false})
		event(wrapper, 'mousewheel', handle_event, {passive: false})
		event(wrapper, 'DOMMouseScroll', handle_event, {passive: false})

		event(window, 'orientationchange', handle_event);
		event(window, 'resize', handle_event)


		event(wrapper, 'click', handle_event, {capture: true})

		if (enable_mouse_events) {
			event(wrapper, 'mousedown', handle_event);
			event(target, 'mousemove', handle_event);
			event(target, 'mousecancel', handle_event);
			event(target, 'mouseup', handle_event)
		}

		if (enable_pointer_events) {
			event(wrapper, prefix_pointer_event('pointerdown'), handle_event);
			event(target, prefix_pointer_event('pointermove'), handle_event);
			event(target, prefix_pointer_event('pointercancel'), handle_event);
			event(target, prefix_pointer_event('pointerup'), handle_event)
		}

		if (enable_touch_events) {
			event(wrapper, 'touchstart', handle_event)
			event(target, 'touchmove', handle_event, {passive: false})
			event(target, 'touchcancel', handle_event)
			event(target, 'touchend', handle_event)
		}

		event(scroller, 'animationiteration', handle_event, {passive: false})
		event(scroller, 'animationstart', handle_event, {passive: false})
		/*event(scroller, 'transitionend', handle_event)
		 event(scroller, 'transitionrun', handle_event)
		 event(scroller, 'webkitTransitionEnd', handle_event)
		 event(scroller, 'webkitTransitionRun', handle_event)
		 event(scroller, 'oTransitionEnd', handle_event)
		 event(scroller, 'oTransitionRun', handle_event)
		 event(scroller, 'MSTransitionEnd', handle_event)
		 event(scroller, 'MSTransitionRun', handle_event)*/
	}

	function trigger_event (type)
	{
		/*switch (type) {
		 case 'scroll':
		 on_scroll()
		 break
		 case 'startScrolling':
		 on_start_scroll()
		 break
		 case 'endScrolling':
		 on_end_scroll()
		 break
		 }*/

		if (!events[type]) {
			return;
		}

		let i = 0,
		l = events[type].length

		if (!l) {
			return;
		}

		for (; i < l; i++) {
			events[type][i].apply(null, [].slice.call(arguments, 1));
		}
	}

	function reset_position (time)
	{
		if (!carousel) {
			time = time || 0

			let x2 = x
			let y2 = y

			if (!has_horizontal_scroll || x > 0) {
				x2 = 0;
			}
			else if (x < max_scrollx) {
				x2 = max_scrollx;
			}

			if (!has_vertical_scroll || y > 0) {
				y2 = 0
			}
			else if (y < max_scrolly) {
				y2 = max_scrolly
			}

			if (x2 !== x || y2 !== y) {
				scroll_to(x2, y2, time, bounce_easing);
				return true;
			}
		}

		return false
	}

	function apply_scroll_transform (new_x, new_y)
	{
		/*if (x !== new_x || y !== new_y) {
		 }*/

		x = new_x
		y = new_y

		//do_translate(x, y, scroller_style)
		translate(x, y)
	}

	function do_translate (x, y, s)
	{
		x = calc_pos(x)
		y = calc_pos(y)

		translate_style(x, y, s)
	}
	function translate_style (x, y, s)
	{

		//s[style.willChange] = 'transform'
		//	s[style.transform] = `translate3d(${x}px, ${y}px, 0) scale(1)`

		s.setProperty('--ui-translate-x', `${x}px`)

		//const matrix = `matrix(1,0,0,1,${x},0`

		//s[style.transform] = matrix
	}

	function translate (x1, y1)
	{

		dest_x = x1
		dest_y = y1

		log(`request translation x=${x1} y=${y1}`)


//		ticker.listen(repaint)

		/*if (dest_x !== x1 || dest_y !== y1) {


		 //scroller_style[style.transform] = 'translate(' + x + 'px,' + y + 'px)' + translateZ

		 /!*if (use_transform) {
		 scroller_style[style.transform] = 'translate(' + x1 + 'px,' + y1 + 'px)' + translateZ
		 } else {
		 x1 = Math.round(x1)
		 y1 = Math.round(y1)

		 scroller_style.left = x1 + 'px'
		 scroller_style.top = y1 + 'px'
		 }*!/

		 //log('translate to destination x=' + x1 + ', y=' + y1)


		 //dest_x = x1
		 dest_y = y1


		 //repaint()

		 /!*for (let i = indicators.length; i--;) {
		 indicators[i].update_position();
		 }*!/
		 }*/
	}

	function transition_timing_function (easing)
	{
		transition_timing_function_val = easing
	}

	function transition_time (time)
	{
		time = time || 0

		log("transition time " + time)

		time = Math.round(time)
		transition_time_val = time
		if (time > 0) {
			is_in_transition = 1
		}

		/*if (time === 0) {
		 is_in_transition = 0
		 }*/
	}

	function scroll_to (new_x, new_y, time, easing)
	{
		easing = easing || ease.swipe
		duration = time || 0
		//dest_x = new_x
		//dest_y = new_y
		start_time = now()
		dest_time = start_time + duration

		transition_timing_function(easing.fn)
		transition_time(duration)

		translate(new_x, new_y)
	}

	function enable ()
	{
		ticker.subscribe(repaint)
		ticker.sleep()
		enabled = true
	}

	function offset (elem)
	{
		let left = -elem.offsetLeft,
		top = -elem.offsetTop;

		while ((elem = elem.offsetParent)) {
			left -= elem.offsetLeft;
			top -= elem.offsetTop;
		}

		return {
			left: left,
			top: top
		};
	}

	function on_scroll ()
	{
		//reorder_items()
	}


	function log (m)
	{
		//console.log(m)
	}

	function repaint ()
	{


		if (use_transform) {

			let new_x = dest_x
			let new_y = dest_y

			if (now() >= dest_time) {
				transition_timing_function_val = undefined

				on_transition_end()
			}

			if (transition_timing_function_val) {
				const t = (now() - start_time) / duration
				const easing = transition_timing_function_val(t)

				new_x = (dest_x - start_x) * easing + start_x
				new_y = (dest_y - start_y) * easing + start_y
			}

			reorder_items(new_x, new_y)

			do_translate(x, y, scroller_style)

			x = new_x
			y = new_y
		}
		else {
			/*x1 = Math.round(x1)
			 y1 = Math.round(y1)*/

			scroller_style.left = x + 'px'
			scroller_style.top = y + 'px'
		}


	}

	function start_repaint ()
	{
		//ticker.listen(repaint)
	}

	/*function start_repaint ()
	 {
	 let fps = 240,
	 lag_threshold = 500, adjusted_lag = 33,
	 start_time = now(),
	 last_paint = start_time,
	 fps_interval = 1000 / fps,
	 next_time = fps_interval

	 function do_repaint ()
	 {
	 let elapsed = now() - last_paint, overlap, time, dispatch
	 elapsed > lag_threshold && (start_time += elapsed - adjusted_lag)
	 last_paint += elapsed
	 time = last_paint - start_time
	 overlap = time - next_time

	 if (overlap > 0) {
	 next_time += overlap + (overlap >= fps_interval ? 4 : fps_interval - overlap)
	 dispatch = 1
	 }

	 if (scrolling) {
	 req_frame(do_repaint)
	 }

	 if (dispatch/!*elapsed > fps_interval*!/) {
	 //then = now() - (elapsed % fps_interval)
	 repaint()

	 } else {
	 log("no repaint")
	 }
	 }

	 req_frame(do_repaint)
	 }*/

	function on_start_scroll ()
	{
//		scrolling = true
		//start_repaint()

		trigger_event('scrollstart')

		ticker.wake()

		log('on_start_scroll')
	}

	function on_end_scroll ()
	{
//		scrolling = false

		ticker.sleep()

		trigger_event('scrollend')

		dist_x = 0
		dist_y = 0
		direction_locked = undefined

		log('on_end_scroll')
	}

	function calc_pos (n)
	{
		//console.log(`${n} % ${modulus} = ${n % modulus}`)

		return n % modulus
	}


	function reorder_items (x, y)
	{
		if (!infinite) {
			return
		}

		const real_pos = scrollx ? x : y;
		const pos = calc_pos(real_pos)

		const m = v => carousel ? v : Math.max(v, 0)

		let minor_phase = m(Math.floor(-pos / item_size) - infinite_upper_buffer_size),
		major_phase = Math.floor(minor_phase / items.length),
		phase = minor_phase - major_phase * items.length,
		real_minor_phase = m(Math.floor(-real_pos / item_size) - infinite_upper_buffer_size),
		real_major_phase = Math.floor(real_minor_phase / items.length),
		real_phase = real_minor_phase - real_major_phase * items.length, item
		let top_or_left = 0, real_top_or_left = 0, i = 0
		const update = []
		log("minor: " + minor_phase)
		log("major: " + major_phase)
		log("phase: " + phase)
		log("pos: " + pos)
		log("real_pos: " + real_pos)
		log("items_per_page: " + items_per_page)
		log("items_size: " + item_size)
		log("items: " + items.length)
		log('infinite_upper_buffer_size ' + infinite_upper_buffer_size)
		while (i < items.length) {

			item = items[i]

			top_or_left = i * item_size + major_phase * items_size
			real_top_or_left = i * item_size + real_major_phase * items_size


			if (phase > i) {
				top_or_left += items_size
			}

			if (real_phase > i) {
				real_top_or_left += items_size
			}

			log("i: " + i + " top_or_left: " + top_or_left)
			log("i: " + i + " real_top_or_left: " + real_top_or_left)

//			if (item._top !== top_or_left) {

			item._phase = top_or_left / item_size
			item._idx = real_top_or_left / item_size

			if (item._phase < infinite_limit) {
				if (infinite_use_transform) {

					top_or_left = top_or_left - (i * item_size)

					const x = scrollx ? top_or_left : 0
					const y = scrolly ? top_or_left : 0

					if(item._pos !== top_or_left) {
						console.log("translate item")
						item._pos = top_or_left
						translate_style(x, y, item.style)
					}
				}
				else if (scrolly) {
					item.style.top = top_or_left + 'px'
				}
				else if (scrollx) {
					item.style.left = top_or_left + 'px'
				}

				update.push(item)
			}
			//} else {
			//item.style['background'] = 'white';

			//}

			i++
		}

		update_rows(update)
	}

	function update_rows (items)
	{
		if(update_row!==null) {
			let i, l
			for (i = 0, l = items.length; i < l; i++) {
				const idx = items[i]._idx;
				if (idx < infinite_limit) {
					update_row(idx, items[i])
				}
			}
		}
	}

	function create_scrollbar (direction)
	{
		let scrollbar = document.createElement('div'),
		indicator = document.createElement('div')

		const type = true

		scrollbar.style.cssText = `
        position:absolute;
        z-index:9999;
      `
		indicator.style.cssText = `
        -webkit-box-sizing:border-box;
        -moz-box-sizing:border-box;
        box-sizing:border-box;
        position:absolute;
        background:rgba(0,0,0,0.5);
        border:1px solid rgba(255,255,255,0.9);
        border-radius:3px;
        left: 0;
        top: 0;
        height: 40px;
      `

		indicator.className = 'indicator'

		if (direction == 'h') {
			if (type === true) {
				scrollbar.style.cssText += `
            height:7px;
            left:2px;
            right:2px;
            bottom:0
          `

				indicator.style.height = '100%';
			}
			scrollbar.className = 'horizontal scrollbar';
		}
		else {
			if (type === true) {
				scrollbar.style.cssText += `
            width:7px;
            bottom:2px;
            top:2px;
            right:1px
          `;

				indicator.style.width = '100%';
			}
			scrollbar.className = 'vertical scrollbar';
		}

		scrollbar.style.cssText += `
        overflow:hidden
      `

		scrollbar.appendChild(indicator)

		return scrollbar
	}

	function init_indicators ()
	{
		let indicator, list = []

		if (scrolly) {
			indicator = {
				wrapper: create_scrollbar('v'),

			}

			wrapper.appendChild(indicator.wrapper)
			list.push(indicator)
		}

		for (let i = list.length; i--;) {
			indicators.push(new_indicator(scroll, list[i]));
		}
	}

	function refresh ()
	{
		console.log('refresh')

		const wrapper_rect = rect(wrapper)

		wrapper_width = wrapper_rect.outer_width
		wrapper_height = wrapper_rect.outer_height

		items = typeof items == 'string' ? [...wrapper.querySelectorAll(items)] : items

		initial_len = initial_len || items.length

		item_master = items ? items[0] : undefined

		/*if(update_row {
			update_row(0, items[0]) // update master
		}*/

		item_height = item_master ? rect(item_master).height : 0
		item_width = item_master ? rect(item_master).width : 0

		if (scrollx) {
			items_per_page = Math.floor(wrapper_width / item_width)
		}
		else if (scrolly) {
			items_per_page = Math.floor(wrapper_height / item_height)
		}

		//items_per_page = items_per_page + 1;
		if (infinite) {

//			let item = item_master
//			const initial_len = items.length

			const parent_node = item_master.parentNode
			const total_item_count = Math.max(items_per_page * 3, initial_len * 3)
			for (let i = items.length; i < total_item_count; i++) {
				const new_item = items[i % initial_len].cloneNode(true)
				parent_node.appendChild(new_item)
				items.push(new_item)
			}

			/*while (items.length < ) {
				const new_item = item.cloneNode(true)
				item_master.parentNode.appendChild(new_item)
				items.push(new_item)
				item = item.nextElementSibling || item_master
			}*/
		}

		for (let i = 0; i < items.length; i++) {
			const item = items[i]

			item._top = 0
			//item.style.width = item_width + 'px';


			/*if (scrollx) {
			 item.style.position = 'absolute'
			 item.style.left = i * item_width + 'px'
			 item.style.float = 'none'
			 }*/
		}

		infinite_upper_buffer_size = Math.floor((items.length - items_per_page) / 2)

		items_height = items.length * item_height
		items_width = items.length * item_width
		item_size = scrollx ? item_width : item_height
		items_size = scrollx ? items_width : items_height

		const max = 2147483645;
		//const max = 65536;
		infinite_limit = infinite_limit || Math.floor(max / items_size)

		scroller_size = item_size * items.length

		if (scrollx) {
			scroller_width = scroller_size
			//scroller.style.width = (scroller_width = scroller_size) + 'px'

//			scroller.style.top = '0';
//			scroller.style.bottom = '0';

//			scroller.style.height = item_height


		}
		else {
			scroller.style.width = (scroller_width = item_width) + 'px'
			scroller.style.height = (scroller_height = scroller_size) + 'px'
			wrapper.style.width = scroller.style.width
			scroller.style.left = '0';
			scroller.style.right = '0';
		}

		const limit = infinite ? (-infinite_limit * item_size + (scroller_size - (item_size * items.length))) : undefined

		max_scrollx = limit ? limit : wrapper_width - scroller_width
		max_scrolly = limit ? limit : wrapper_height - scroller_height
		min_scrollx = 0
		min_scrolly = 0
		has_horizontal_scroll = scrollx && max_scrollx < 0
		has_vertical_scroll = scrolly && max_scrolly < 0

		if (!has_horizontal_scroll) {
			max_scrollx = 0;
			scroller_width = wrapper_width;
		}

		if (!has_vertical_scroll) {
			max_scrolly = 0;
			scroller_height = wrapper_height;
		}

		end_time = 0
		direction_x = 0
		direction_y = 0

		if (has_pointer) {
			wrapper.style[style.touchAction] = touch_action(events_passthrough, true)
			if (!wrapper.style[style.touchAction]) {
				// if no pinch-zoom support
				wrapper.style[style.touchAction] = touch_action(events_passthrough, false);
			}
		}

		modulus = scroller_width * 2

		console.log('scroller_width '  + scroller_width)
		console.log('item_width '  + item_width)
		console.log('modulus '  + modulus)
		console.log('items.length  ' + items.length)

		wrapper_offset = offset(wrapper)

		//reorder_items(x, y)

		trigger_event('refresh')

		reset_position()

		refresh_snap()
	}

	function scroll_to_page (x, y, time, easing)
	{
		//alert(x)

		let px = x, py = y

		if (x >= pages.length) {
			px = x % pages.length
		}
		else if (x < 0) {
			px = Math.abs(pages.length + x) % pages.length
		}

		/*if (x >= pages.length) {
		 x = pages.length - 1
		 } else if (x < 0) {
		 x = 0
		 }

		 if (y >= pages[x].length) {
		 y = pages[x].length - 1
		 } else if (y < 0) {
		 y = 0
		 }*/

		log(`scroll_to_page x=${x} y=${y}`)

		const pos_x = x * pages[px][py].width,
		pos_y = y * pages[px][py].height

		log(`page coordinates x=${pos_x} y=${pos_y}`)

		time = time === undefined ? snap_speed || Math.max(
		Math.max(
		Math.min(Math.abs(pos_x - x), 1000),
		Math.min(Math.abs(pos_y - y), 1000)), 300) : time

		current_page = {
			x: pos_x,
			y: pos_y,
			page_x: x,
			page_y: y
		}

		scroll_to(pos_x, pos_y, time, easing)
	}

	function refresh_snap ()
	{
		let i = 0, l,
		m = 0, n,
		cx, cy,
		x = 0, y,
		step_x = snap_step_x || wrapper_width,
		step_y = snap_step_y || wrapper_height,
		el,
		r

		pages = []

		const has_layout = wrapper_width && wrapper_height && scroller_width && scroller_height
		const snap_enabled = snap === true || snap && snap.length
		if (snap_enabled) {
			if (snap === true && has_layout) {
				cx = Math.round(step_x / 2)
				cy = Math.round(step_y / 2)
				while (x > -scroller_width) {
					pages[i] = []
					l = 0
					y = 0
					while (y > -scroller_height) {
						pages[i][l] = {
							x: Math.max(x, max_scrollx),
							y: Math.max(y, max_scrolly),
							width: step_x,
							height: step_y,
							cx: x - cx,
							cy: y - cy
						}

						y -= step_y
						l++
					}

					x -= step_x
					i++
				}
			}
			else {has_layout && snap && snap.length}
			{
				l = snap.length
				n = -1
				for (; i < l; i++) {
					r = rect(snap[i])
					if (i === 0 || r.left <= rect(snap[i - 1]).left) {
						m = 0
						n++
					}

					if (!pages[m]) {
						pages[m] = [];
					}

					x = Math.max(-r.left, max_scrollx)
					y = Math.max(-r.top, max_scrolly)
					cx = x - Math.round(r.width / 2)
					cy = y - Math.round(r.height / 2)

					pages[m][n] = {
						x: x,
						y: y,
						width: r.width,
						height: r.height,
						cx: cx,
						cy: cy
					}

					if (x > max_scrollx) {
						m++;
					}
				}
			}

			scroll_to_page(current_page.page_x || 0, current_page.page_y || 0, 0)

			if (snap_threshold % 1 === 0) {
				snap_threshold_x = snap_threshold;
				snap_threshold_y = snap_threshold;
			}
			else {
				snap_threshold_x = Math.round(pages[current_page.page_x][current_page.page_y].width * snap_threshold);
				snap_threshold_y = Math.round(pages[current_page.page_x][current_page.page_y].height * snap_threshold);
			}
		}
	}

	install_events(false)
	refresh()
	scroll_to(startx, starty)
	init_indicators()
	enable()

	scroller.classList.add('gt-marquee')

	return scroll
}

function new_indicator (scroll, {
	wrapper = undefined,
	listen_x = true,
	listen_y = true,
	shrink = 'scale',
	ignore_boundaries = false,
	interactive = false,
	resize = true,
	fade = false,
	speed_ratio_x = 0,
	speed_ratio_y = 0
})
{
	const indicator = wrapper.children[0],
	indicator_style = indicator.style

	let size_ratio_x = 1,
	size_ratio_y = 1,
	max_pos_x = 0,
	max_pos_y = 0,
	max_boundary_x,
	max_boundary_y,
	min_boundary_x,
	min_boundary_y,
	indicator_width,
	indicator_height,
	width,
	height

	if (interactive) {
		// TODO
	}

	if (fade) {
		// TODO
	}

	return {
		destroy: function ()
		{

		},

		refresh: function () {

		},

		update_position: function ()
		{
			let x = (listen_x && Math.round(size_ratio_x * scroll.x()) || 0)
			let y = (listen_y && Math.round(size_ratio_y * scroll.y()) || 0)

			if (!ignore_boundaries) {
				if (x < min_boundary_x) {
					if (shrink === 'scale') {
						width = Math.max(indicator_width + x, 8)
						indicator_style.width = width + 'px'
					}
					x = min_boundary_x
				}
				else if (x > max_boundary_x) {
					if (shrink === 'scale') {
						width = Math.max(indicator_width - (x - max_pos_x), 8)
						indicator_style.width = width + 'px'
						x = max_pos_x + indicator_width - width
					}
					else {
						x = max_boundary_x
					}
				}
				else if (shrink === 'scale' && width !== indicator_width) {
					width = indicator_width;
					indicator_style.width = width + 'px';
				}
			}

			if (y < min_boundary_y) {
				if (shrink === 'scale') {
					height = Math.max(indicator_height + y * 3, 8);
					indicator_style.height = height + 'px';
				}
				y = min_boundary_y;
			}
			else if (y > max_boundary_y) {
				if (shrink === 'scale') {
					height = Math.max(indicator_height - (y - max_pos_y) * 3, 8);
					indicator_style.height = height + 'px';
					y = max_pos_y + indicator_height - height;
				}
				else {
					y = max_boundary_y;
				}
			}
			else if (shrink === 'scale' && height !== indicator_height) {
				height = indicator_height;
				indicator_style.height = height + 'px';
			}
		}
	}
}